import React, { useState } from "react";
import API from "../utils/API";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv } from "@fortawesome/free-solid-svg-icons";
import { Spinner } from "reactstrap";

const PREFERRED_ORDER = ["id", "date", "status", "product", "revenue", "subid"];

function escapeCsvValue(v) {
    const s = v != null ? String(v) : "";
    if (s.includes(",") || s.includes('"') || s.includes("\n") || s.includes("\r")) {
        return '"' + s.replace(/"/g, '""') + '"';
    }
    return s;
}

function buildCsv(data, orderedKeys) {
    const header = orderedKeys.map(escapeCsvValue).join(",");
    const rows = data.map((row) => orderedKeys.map((key) => escapeCsvValue(row[key])).join(","));
    return [header, ...rows].join("\r\n");
}

function normalizeRowsAndGetOrderedKeys(data) {
    if (!Array.isArray(data) || data.length === 0) return { data: [], orderedKeys: [] };
    const keySet = new Set();
    data.forEach((row) => Object.keys(row).forEach((k) => keySet.add(k)));
    const orderedKeys = [
        ...PREFERRED_ORDER.filter((k) => keySet.has(k)),
        ...[...keySet].sort().filter((k) => !PREFERRED_ORDER.includes(k)),
    ];
    const normalized = data.map((row) => {
        const out = {};
        orderedKeys.forEach((key) => {
            const v = row[key];
            out[key] = v != null ? String(v) : "";
        });
        return out;
    });
    return { data: normalized, orderedKeys };
}

function downloadCsv(content, filename) {
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + content], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${filename}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

const CSVDownlaod = ({ url, filename, filtration }) => {
    const [csvLoading, setCsvLoading] = useState(false);

    const handleDownload = async () => {
        setCsvLoading(true);
        try {
            const response = filtration
                ? await API.post(url, filtration)
                : await API.get(url);
            const raw = response.data.data;
            const { data, orderedKeys } = normalizeRowsAndGetOrderedKeys(raw);
            const csv = buildCsv(data, orderedKeys);
            downloadCsv(csv, filename);
        } finally {
            setCsvLoading(false);
        }
    };

    return (
        <>
            {!csvLoading ? (
                <span onClick={handleDownload} role="button" onKeyDown={(e) => e.key === "Enter" && handleDownload()} tabIndex={0}>
                    <FontAwesomeIcon
                        className="align-middle cursor-pointer"
                        icon={faFileCsv}
                        style={{ fontSize: "20px" }}
                        fixedWidth
                    />
                </span>
            ) : (
                <Spinner style={{ width: "25px", height: "25px" }} />
            )}
        </>
    );
};

export default CSVDownlaod;
